export default "__VITE_ASSET__773d4e6c__"